import { AfspLayout } from '@bit/ui-common.ui-components/afsp';
import { commonData, HelpLayout } from '@bit/ui-common.ui-components/ss-common-data';
import { Container, ResourceIndicator } from '@bit/ui-common.ui-components/ss-components';
import tsaLogo from '@bit/ui-common.ui-components/afsp/images/dhs-logo-01.png';
import userIcon from '@bit/ui-common.ui-components/afsp/images/user-icon-01.png';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const 
{ getPathParams } = ssCommonUtils,
layout = {
    size: {
        header: 'xs',
        footer: 'xs'
    },
    images: {
        logo: tsaLogo,
        user: userIcon
    },
    controlType: 'home',
    bgc: '#e6e6e6'
};


export default Container({ 
    state: s => ({ commonData: s.commonData }), 
    services: [ commonData.commonDataServices ]
},
class Help extends React.Component {
    constructor(props) { 
        super(props); 
        const { services } = this.props;
        services.fetchTextData();
        services.fetchGeoData();
        services.fetchLookupData();
    }

    render() {
        const 
        { textData, geoData, lookupData } = this.props.commonData,
        { view, tab } = getPathParams();

        return (
            <div>
                <ResourceIndicator resources={{ textData, geoData, lookupData }} />
                <AfspLayout {...layout}>
                    <HelpLayout 
                        theme='light' 
                        space='xl' 
                        portal={view.toLowerCase()} 
                        defaultTab={tab.toUpperCase()} 
                    />
                </AfspLayout>
            </div>
        )
    }
});